import axios from 'axios';

import { API_BASE_URL } from './apiBase';

const API_URL = API_BASE_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Scenarios
export const scenarioAPI = {
  calculate: (data) => api.post('/calculate', data),
  preview: (data) => api.post('/calculate/preview', data),
  getAll: () => api.get('/scenarios'),
  getOne: (id) => api.get(`/scenarios/${id}`),
  delete: (id) => api.delete(`/scenarios/${id}`),
  exportPdf: (id) => api.get(`/scenarios/${id}/pdf`, { responseType: 'blob' }),
};

// Regional data
export const regionAPI = {
  getAll: () => api.get('/regions'),
  getDefaults: (region) => api.get(`/regions/${region}`),
};

// Translations
export const translationAPI = {
  get: (language) => api.get(`/translations/${language}`),
  getAll: () => api.get('/translations'),
};

// Sensitivity analysis
export const sensitivityAPI = {
  analyze: (data) => api.post('/sensitivity', data),
};

// CSV import
export const importAPI = {
  csv: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/import/csv', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default api;
